module.exports = __webpack_public_path__ + "media/img/frontend_application/country/th-c07963fa88157042b5bd57c77574fd7d.jpg";